const GAMEBOARD_VERSION = "/v2";

export default {
  methods: {
    getGameUrl(id) {
      return `/games${GAMEBOARD_VERSION}/${id}`;
    },

    getTournamentGameUrl(tournamentId, id) {
      return `/tournaments/${tournamentId}/games${GAMEBOARD_VERSION}/${id}`;
    },
  },
};
